export function getLocalizedLink(currentLocale: string, path: string) {
  if (currentLocale && !['pt', 'pt-BR', 'pt-br'].includes(currentLocale))
    return `/${currentLocale}${path}`

  return path
}
